import { toastr as toast } from 'react-redux-toastr';
import type * as React from 'react';

export interface IToastMessage {
	title?: string;
	body: string;
	options?: IToastOptions;
}

export interface IToastOptions {
	timeOut?: number;
	icon?: JSX.Element;
	onShowComplete?: () => void;
	onHideComplete?: () => void;
	onCloseButtonClick?: () => void;
	onOk?: () => void;
	onCancel?: () => void;
	okText?: string;
	cancelText?: string;
	disableCancel?: boolean;
	showCloseButton?: boolean;
	transitionIn?: 'bounceIn' | 'bounceInDown' | 'fadeIn';
	transitionOut?: 'bounceOut' | 'bounceOutUp' | 'fadeOut';
	position?:
		| 'top-left'
		| 'top-center'
		| 'top-right'
		| 'bottom-left'
		| 'bottom-center'
		| 'bottom-right';
	progressBar?: boolean;
	component?: React.Component | JSX.Element;
}

export const toastr = {
	success: (toastMessage: IToastMessage) => {
		toast.success(toastMessage.title, toastMessage.body, toastMessage.options);
	},
	error: (toastMessage: IToastMessage) => {
		toast.error(toastMessage.title, toastMessage.body, toastMessage.options);
	},
	info: (toastMessage: IToastMessage) => {
		toast.info(toastMessage.title, toastMessage.body, toastMessage.options);
	},
	warning: (toastMessage: IToastMessage) => {
		toast.warning(toastMessage.title, toastMessage.body, toastMessage.options);
	},
	confirm: (toastMessage: IToastMessage) => {
		toast.confirm(toastMessage.body, toastMessage.options);
	},
};
